
'use client';

import { NextIntlClientProvider } from 'next-intl';

import { getMessageFallback } from './request';

export function IntlWrapper(props) {
  return (
    <NextIntlClientProvider
      onError={() => {}}
      getMessageFallback={getMessageFallback}
      {...props}
    />
  );
}
